<div class="auth-page-wrapper public-page">
	<div class="login-wave-header"></div>

	<div class="login-header">
		<img src="assets/images/Logo-KeFirma.png" alt="KeFirma" class="login-logo" />
	</div>

	<div class="form-page-wrapper">
		<div class="mb-4 text-center login-intestazioni">
			<h1>Accedi al tuo account</h1>
			<p class="text-muted-kf">Bentornato! Inserisci i tuoi dati per accedere.</p>
		</div>

		<form (ngSubmit)="login()" #loginForm="ngForm">
			<div class="form-group">
				<label class="form-label-kf" for="username">Username</label>
				<input
					id="username"
					type="email"
					class="form-control-kf"
					[class.is-invalid]="loginError"
					placeholder="test@mail.com"
					[(ngModel)]="username"
					name="username"
					required
					autocomplete="username" />
			</div>

			<div class="form-group">
				<label class="form-label-kf" for="password">Password</label>
				<div class="form-input-wrapper">
					<input
						id="password"
						[type]="showPassword ? 'text' : 'password'"
						class="form-control-kf"
						[class.is-invalid]="loginError"
						placeholder="••••••••••••••"
						[(ngModel)]="password"
						name="password"
						required
						autocomplete="current-password" />
					<i class="form-input-icon bi" [class.bi-eye]="!showPassword" [class.bi-eye-slash]="showPassword" (click)="showPassword = !showPassword"></i>
				</div>
				@if (loginError) {
					<span class="form-error">
						<i class="bi bi-exclamation-circle-fill"></i>
						Password errata.
					</span>
				}
			</div>

			<div class="mt-4">
				<button type="submit" class="btn-kf-primary w-100" [disabled]="loading">
					@if (loading) {
						<span class="spinner-border spinner-border-sm me-2"></span>
					}
					ACCEDI
				</button>
			</div>
		</form>

		<div class="text-center mt-3 d-flex flex-column gap-2">
			<button class="btn-kf-link mt-2" type="button" (click)="goToRecuperaPassword()">Hai dimenticato la password?</button>

			<div class="separator-container my-2">
				<div class="separator-line"></div>
				<div class="separator-text">oppure</div>
				<div class="separator-line"></div>
			</div>

			<button type="button" class="btn-microsoft w-100" (click)="loginMicrosoft()" [disabled]="loading">
				<img
					src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='21' height='21' viewBox='0 0 21 21'%3E%3Cpath fill='%23f25022' d='M1 1h9v9H1z'/%3E%3Cpath fill='%237fba00' d='M11 1h9v9h-9z'/%3E%3Cpath fill='%2300a4ef' d='M1 11h9v9H1z'/%3E%3Cpath fill='%23ffb900' d='M11 11h9v9h-9z'/%3E%3C/svg%3E"
					alt="Microsoft" />
				<span>Accedi con Microsoft</span>
			</button>
		</div>
	</div>

	<div class="login-wave-footer"></div>
</div>
